import React from 'react';

interface LessonIconProps {
  type: string;
}

const LessonIcon: React.FC<LessonIconProps> = ({ type }) => {
    
  const KeyIcon = ({ keys }: { keys: string }) => (
    <svg viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect x="4" y="10" width="40" height="28" rx="4" stroke="currentColor" strokeWidth="3" fill="white"/>
      <text x="24" y="31" fontFamily="monospace" fontSize="18" fontWeight="bold" textAnchor="middle" fill="currentColor">
        {keys}
      </text>
    </svg>
  );

  const icons: { [key: string]: React.ReactElement } = {
    introduction: (
      <svg viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect x="4" y="8" width="40" height="28" rx="3" stroke="currentColor" strokeWidth="3" fill="white" />
        <rect x="16" y="36" width="16" height="4" rx="1" fill="currentColor" />
        <path d="M21 18V30L31 24L21 18Z" stroke="currentColor" strokeWidth="3" strokeLinejoin="round" fill="white" />
      </svg>
    ),
    practice: (
      <svg viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
        <circle cx="24" cy="24" r="16" stroke="currentColor" strokeWidth="3" fill="white"/>
        <path d="M24 16V24H32" stroke="currentColor" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round"/>
        <path d="M23 8H25V12H23V8Z" fill="currentColor"/>
      </svg>
    ),
    review: (
      <svg viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
        <circle cx="20" cy="20" r="12" stroke="currentColor" strokeWidth="3" fill="white" />
        <path d="M30 30L38 38" stroke="currentColor" strokeWidth="3" strokeLinecap="round"/>
        <text x="20" y="25" fontFamily="monospace" fontSize="12" fontWeight="bold" textAnchor="middle" fill="currentColor">
            sl
        </text>
      </svg>
    ),
    game: (
      <svg viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M24 38C32.8366 38 40 30.8366 40 22C40 13.1634 32.8366 6 24 6C15.1634 6 8 13.1634 8 22C8 30.8366 15.1634 38 24 38Z" stroke="currentColor" strokeWidth="3" fill="white"/>
        <rect x="18" y="38" width="12" height="6" rx="2" stroke="currentColor" strokeWidth="3" fill="white"/>
        <text x="24" y="27" fontSize="12" textAnchor="middle" fill="currentColor">👤</text>
      </svg>
    ),
    home_row: (
       <svg viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect x="4" y="16" width="40" height="12" rx="2" stroke="currentColor" strokeWidth="3" fill="white"/>
        <rect x="8" y="20" width="4" height="4" fill="currentColor" opacity="0.3"/>
        <rect x="14" y="20" width="4" height="4" fill="currentColor" opacity="0.3"/>
        <rect x="20" y="20" width="4" height="4" fill="currentColor" opacity="0.3"/>
        <rect x="26" y="20" width="4" height="4" fill="currentColor" opacity="0.3"/>
        <rect x="32" y="20" width="4" height="4" fill="currentColor" opacity="0.3"/>
      </svg>
    ),
    default: (
      <svg viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect x="4" y="10" width="40" height="28" rx="4" stroke="currentColor" strokeWidth="3" fill="white" />
        <path d="M12 20H18" stroke="currentColor" strokeWidth="2"/>
        <path d="M12 28H24" stroke="currentColor" strokeWidth="2"/>
        <path d="M30 20H36" stroke="currentColor" strokeWidth="2"/>
        <path d="M30 28H36" stroke="currentColor" strokeWidth="2"/>
      </svg>
    ),
  };
  
  // Handle specific key combinations
  if (type.includes('&')) {
      return <KeyIcon keys={type.replace('&', ' ')} />
  }

  return icons[type] || icons.default;
};

export default LessonIcon;
